import { createFileRoute } from '@tanstack/react-router'
import { NotFoundPage } from '@/routes/__root'

// An address no page answers opens inside the app, with the sidebar still there
// to leave it, instead of the bare root fallback.
export const Route = createFileRoute('/(private)/$')({
	component: NotFoundPage
})
